import { Injectable } from '@angular/core';
import { dealDateTime } from '../../common/calendar';
import { BasicService } from '../../services/basic.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerInfoService extends BasicService {
  parseMeterWarehouseQueryFields(settingValue?: string): string[] {
    const allowedFields = ['steelMark', 'sealNumber'];
    const fields = (settingValue || '')
      .split(',')
      .map(field => field.trim())
      .filter(field => allowedFields.indexOf(field) !== -1);

    return fields.filter((field, index) => fields.indexOf(field) === index);
  }

  queryOutMeterInfo(queryField: 'steelMark' | 'sealNumber', queryValue: string) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterInfo/queryOutMeterInfo`,
      params: {
        queryField,
        queryValue,
      },
    });
  }

  // 检查是否可以修改供水合同号
  checkCustCanAlterContract(custCode) {
    return this.post({
      url: `${this.apiUrl}/api/app/custContract/checkCanUpdateContractNo`,
      params: {
        custCode,
      },
    });
  }

  // 查询客户供水合同状态
  checkCustContractStatus(custCode) {
    return this.get({
      url: `${this.apiUrl}/api/app/custContract/custContractStatus`,
      params: {
        custCode,
      },
    });
  }

  exportCustPayTotalLogsList(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/payments/exportPaySubtotal`,
      body,
      headers,
      options,
    });
  }

  // 余量抵扣
  useSurplusWater(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/surplusWater/surplusWater`,
      body,
    });
  }

  updateCustSurplusWater(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/updateCustSurplusWaterByCustId`,
      body,
    });
  }

  syncInvoiceType(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/invoiceRecord/resetInvoiceType`,
      body,
    });
  }

  updateCustReading(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterReading/updateReadingForRecordId`,
      body,
    });
  }

  updateCustBillInfo(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/charge/updateChargeCustInfo`,
      body,
    });
  }

  // 获取用户分组列表
  getCustGroups(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/custGroup/custGroups`,
      params: {
        field: value.field,
        SkipCount: value.SkipCount,
        MaxResultCount: value.MaxResultCount,
      },
    });
  }

  // （添加/修改）客户组
  postaddCustGroups(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custGroup/custGroupAddOrEdit`,
      body: value,
    });
  }

  // 词语
  getWordItems(key: string) {
    return this.get({
      url: `${this.apiUrl}/api/app/words/wordItemsByGroupKey`,
      params: {
        groupKey: key,
      },
    });
  }

  // TODO 用户信息开始
  getCustomerList(pageAssistant) {
    pageAssistant.CustCode = pageAssistant.CustCode?.replace(/\s/g, '');
    return this.post({
      url: `${this.apiUrl}/api/app/cust/custPageList`,
      body: pageAssistant,
    });
  }

  getCustomerTotal(pageAssistant) {
    pageAssistant.CustCode = pageAssistant.CustCode?.replace(/\s/g, '');
    return this.post({
      url: `${this.apiUrl}/api/app/custTotal/custTotal`,
      body: pageAssistant,
    });
  }

  // getCustomerBookItems(code) {
  //   return this.get({
  //     url: `${this.apiUrl}/api/app/meterBook/bookItemByCode`,
  //     params: {
  //       bookCode: code
  //     }
  //   });
  // }

  getCustOwe(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/payments/custOwe/${id}`,
    });
  }

  // 导出
  // exportCustData(value) {
  //   const res = this.getOptions({}, {}, {responseType: 'blob'});
  //   return this.get({
  //     url: `${this.apiUrl}/api/app/cust/exportCustData`,
  //     params: value,
  //     options: res
  //   });
  // }

  // 客户信息新增功能接口
  // 获取水表厂家
  meterAll(params?: any) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterProducer/meterAll`,
      params: params,
    });
  }

  meterModels(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterModels`,
      params: {
        producereId: id,
      },
    });
  }

  // 获取册本（根据抄表员）
  getBookLists(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterBook/getBookList`,
      body: value,
    });
  }

  // 新增结束

  getAllPriceInfos() {
    return this.get({
      url: `${this.apiUrl}/api/app/system/orgPriceInfos`,
    });
  }

  getPriceInfosByOrgId(orgId) {
    return this.get({
      url: `${this.apiUrl}/api/app/system/priceInfosByOrgId/${orgId}`,
    });
  }

  getPriceDetails(priceCode) {
    // 获取价格信息详情
    return this.get({
      url: `${this.apiUrl}/api/app/system/priceDetails`,
      params: {
        priceCode,
      },
    });
  }

  getCustomerDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/${id}/model`,
    });
  }

  getCustomerDetailByField(field, isAll?, measureLevel?) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/model`,
      params: {
        CustCode: field,
        type: isAll === 2 ? 2 : isAll ? 0 : 1,
        measureLevel,
      },
    });
  }

  getNextCustomerDetail(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/nextModel/${value.bookId}`,
      params: {
        sort: value.sort,
        logo: value.logo,
      },
    });
  }

  getMeterBookListByOrgId(orgId?) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterBook/bookListByOrgId`,
      params: {
        OrgId: orgId,
      },
    });
  }

  getAllMeterBookList(isTemp?) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterBook/bookList`,
      params: {
        isTemp: isTemp ? isTemp : false,
      },
    });
  }

  updateCertificate(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/updateCertificate`,
      body: {
        ...value,
      },
    });
  }

  getPopulationChange(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/population/lastModel/${custId}`,
    });
  }

  createPopulationChange(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/population`,
      body: {
        ...value,
      },
    });
  }

  updatePopulationChange(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/population/update`,
      body: {
        ...value,
      },
    });
  }

  completePopulationChange(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/population/${id}/complete`,
    });
  }

  deletePopulationChange(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/population/${id}/delete`,
    });
  }

  getContactList(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/contact`,
      params: {
        custId,
      },
    });
  }

  deleteContact(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/contact/${id}/delete`,
    });
  }

  updateContact(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/contact/update`,
      body: {
        ...value,
      },
    });
  }

  createContact(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/contactRecord`,
      body: {
        ...value,
      },
    });
  }

  getWithholdingById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/custWithholding/model/${id}`,
    });
  }

  createWithholding(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custWithholding`,
      body: {
        ...value,
      },
    });
  }

  updateCustWithholding(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custWithholding/update`,
      body: {
        ...value,
      },
    });
  }

  updateCustWithholdingSelect(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custWithholding/updateEdit`,
      body: {
        ...value,
      },
    });
  }

  getCollectionById(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/custCollection/model/${id}`,
    });
  }

  createCollection(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custCollection`,
      body: {
        ...value,
      },
    });
  }

  updateCustCollection(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custCollection/update`,
      body: {
        ...value,
      },
    });
  }

  updateCustCollectionSelect(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custCollection/updateEdit`,
      body: {
        ...value,
      },
    });
  }

  updateCustPayMethod(custId, payMethod) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/updatePayMethod/${custId}`,
      params: {
        payMethod,
      },
    });
  }

  getCustInvoice(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/invoice/model/${id}`,
    });
  }
  getCustInvoiceFlow(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/invoice/record/${id}`,
    });
  }

  getCustInvoiceByCustCode(custCode) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/invoice/model/${custCode}/custcode`,
    });
  }

  updateCustInvoiceSelect(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/invoice/updateEdit`,
      body: {
        ...value,
      },
    });
  }

  createCustInvoice(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/invoiceRecord`,
      body: {
        ...value,
      },
    });
  }

  getMeterDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/meter/basicModel/${id}`,
    });
  }

  updateMeterDetail(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/meter/updateMeterBasic`,
      body: {
        ...value,
      },
    });
  }

  getMeterTypeDetail(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/meter/typeModel/${id}`,
    });
  }

  updateMeterTypeDetail(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/meter/updateMeterType`,
      body: {
        ...value,
      },
    });
  }

  getCustBillType(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/custBillType/custMainBillType/${id}`,
    });
  }

  deleteCustBillType(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custBillType/deleteCustBillType`,
      params: {
        custIdArry: value,
      },
    });
  }

  validCustBillType(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/custBillType/valid/${id}`,
    });
  }

  changeCustBillMainType(value) {
    // 主卡修改主卡类型
    return this.post({
      url: `${this.apiUrl}/api/app/custBillType/updateMainType/${value.custId}`,
      params: {
        isBool: value.isBool,
        payMentType: value.payMentType,
      },
    });
  }

  changeCustBillTypeToMain(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custBillType/updateMainChange`,
      body: {
        ...value,
      },
    });
  }

  changeCustBillTypeToMinor(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custBillType/updateMinorChange`,
      body: {
        ...value,
      },
    });
  }

  addMinorChange(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custBillType/minorChange`,
      body: value,
    });
  }

  updateMainCustBillTypeToNormal(custId) {
    return this.post({
      url: `${this.apiUrl}/api/app/custBillType/updateMain/${custId}`,
    });
  }

  updateCust(data) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/update`,
      body: {
        ...data,
      },
    });
  }

  getTotalWaterByCustId(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/lastReading/totalWaterByCustId/${id}`,
    });
  }

  updateTotalWater(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/lastReading/updateTotalWater`,
      body: {
        ...value,
      },
    });
  }

  getLastReadingByCustId(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/lastReading/lastReadingByCustId/${id}`,
    });
  }

  updateLastReading(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/lastReading/updateLastReading`,
      body: {
        ...value,
      },
    });
  }

  //  底码调整
  getAdjustReadingModel(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/adjustReading/model/${custId}`,
    });
  }

  createAdjustReading(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/adjustReading/adjustReading`,
      body: {
        ...value,
      },
    });
  }

  completeAdjustReading(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/adjustReading/${id}/updateComplete`,
    });
  }

  deleteAdjustReading(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/adjustReading/${id}/delete`,
    });
  }

  getMeterReadingRecord(pageAssistant) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterReading/custRecordData`,
      params: {
        ...pageAssistant,
      },
    });
  }

  getDeactivate(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/deactivate/model/${id}`,
    });
  }

  createDeactivate(value) {
    value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/cust/deactivate`,
      body: {
        ...value,
      },
    });
  }

  completeDeactivate(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/deactivate/${id}/updateComplete`,
    });
  }

  deleteDeactivate(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/deactivate/${id}/delete`,
    });
  }

  getUnregister(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/unregister/model/${id}`,
    });
  }

  createUnregister(value) {
    value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/cust/unregister`,
      body: {
        ...value,
      },
    });
  }

  completeUnregister(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/unregister/${id}/updateComplete`,
    });
  }

  deleteUnregister(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/unregister/${id}/delete`,
    });
  }

  getRename(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/rename/model/${custId}`,
    });
  }

  createRename(value) {
    value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/cust/rename`,
      body: {
        ...value,
      },
    });
  }

  completeRename(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/rename/${id}/updateComplete`,
    });
  }

  deleteRename(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/rename/${id}/delete`,
    });
  }

  getContractStatusByRecId(id, type) {
    return this.get({
      url: `${this.apiUrl}/api/app/custContract/contractStatusByRecId/${id}`,
      params: {
        businessType: type,
      },
    });
  }

  getLowInsured(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/lowInsured/model/${custId}`,
    });
  }

  createLowInsured(value) {
    value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/cust/lowInsured`,
      body: {
        ...value,
      },
    });
  }

  completeLowInsured(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/lowInsured/updateComplete`,
      body: {
        ...value,
      },
    });
  }

  deleteLowInsured(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/lowInsured/${id}/delete`,
    });
  }

  getPriceInfosByOrgAndLowState(orgId, lowState) {
    // 获取站点价格信息
    return this.get({
      url: `${this.apiUrl}/api/app/system/priceInfos/${orgId}`,
      params: {
        lowState,
      },
    });
  }

  getPriceChange(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/priceChange/model/${custId}`,
    });
  }

  createPriceChange(value) {
    value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/cust/priceChange`,
      body: {
        ...value,
      },
    });
  }

  completePriceChange(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/priceChange/${id}/updateComplete`,
    });
  }

  deletePriceChange(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/priceChange/${id}/delete`,
    });
  }

  getTransfer(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/transfer/model/${custId}`,
    });
  }

  createTransfer(value) {
    value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/cust/transfer`,
      body: {
        ...value,
      },
    });
  }

  completeTransfer(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/transfer/${id}/updateComplete`,
    });
  }

  deleteTransfer(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/transfer/${id}/delete`,
    });
  }

  getExtraChargeInfo(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/charge/extraInfo/${custId}`,
    });
  }

  getPriceInfoByPriceLog(priceListId) {
    return this.get({
      url: `${this.apiUrl}/api/app/charge/${priceListId}/priceInfosByPriceLog`,
    });
  }

  getPriceItemsByPriceInfo(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/charge/${id}/priceItemsByPriceInfo`,
    });
  }

  calcExtraBill(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/charge/calcExtraBill`,
      body: {
        ...value,
      },
    });
  }

  getCustRefundWater(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/charge/custRefundWater/${custId}`,
    });
  }

  createChargeExtra(value) {
    // value.applyDate = dealDateTime(value.applyDate);
    return this.post({
      url: `${this.apiUrl}/api/app/charge/makeOutExtra`,
      body: {
        ...value,
      },
    });
  }

  getReadStateAll() {
    return this.post({
      url: `${this.apiUrl}/api/app/meterReadState/queryDetailStateAll`,
    });
  }

  getMeterBillRecordList(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterBillRecord/queryRecordList`,
      body: {
        ...value,
      },
    });
  }

  getMeterBillRecordIncludeDeposit(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterBillRecord/depositRecordList`,
      body: value,
    });
  }

  getMeterBillRecordDetail(feeId) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterBillRecord/queryRecordDetail/${feeId}`,
    });
  }

  getPaySubtotalPageList(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/payments/paySubtotalPageList`,
      params: {
        ...params,
      },
    });
  }

  getChangeLogs(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/operationLog/changeLogs`,
      params: {
        CustId: id,
      },
    });
  }

  getCustExistsUnMakeOut(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/charge/existsUnMakeOut/${id}`,
    });
  }

  getCustReadUnReview(id) {
    // 存在未复核数据
    return this.get({
      url: `${this.apiUrl}/api/app/meterReading/readUnReview/${id}`,
    });
  }

  getCustReadUnCheck(id) {
    // 已复核未开账
    return this.get({
      url: `${this.apiUrl}/api/app/meterReading/reviewUnCheck/${id}`,
    });
  }

  getCustReadUnFinish(id) {
    // 未开账
    return this.get({
      url: `${this.apiUrl}/api/app/meterReading/readUnFinish/${id}`,
    });
  }

  getCustRecordState(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterReading/recordState/${custId}`,
    });
  }

  getCustReview(custId, type, deactivateType?) {
    // type 1停用2注销3过户
    return this.get({
      url: `${this.apiUrl}/api/app/cust/custReview/${custId}`,
      params: {
        type,
        deactivateType,
      },
    });
  }

  getCustCanEdit(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/custExists/${custId}`,
    });
  }

  getCustMeterReplace(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterReplace/meterReplace/${custId}`,
    });
  }

  createCustMeterReplace(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/meterReplace/meterReplace`,
      body: {
        ...value,
      },
    });
  }

  completeCustMeterReplace(id) {
    return this.post({
      // url: `${this.apiUrl}/api/app/meterReplace/meterReplace/${custId}`
      url: `${this.apiUrl}/api/app/meterReplace/${id}/updateComplete`,
    });
  }

  deleteCustMeterReplace(id) {
    return this.post({
      // url: `${this.apiUrl}/api/app/meterReplace/meterReplace/${custId}`
      url: `${this.apiUrl}/api/app/meterReplace/${id}/delete`,
    });
  }

  //
  // exportMeterBillLogs(value) {
  //   return this.post({
  //     url: `${this.apiUrl}/api/app/meterBillRecord/exportMeterBillRecordList`,
  //     body: value,
  //     options: {
  //       responseType: 'blob',
  //       observe: 'response',
  //     }
  //   });
  // }

  changeLevelRange(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/changeLevelRange`,
      body: {
        ...value,
      },
    });
  }
  getWaterChangeModel(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/waterChangeModel/${id}`,
    });
  }

  getCustOrderState(id?, code?) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/custOrderState`,
      body: {
        custId: id,
        custCode: code,
      },
    });
  }

  updateGarbageBasicNumber(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/updateGarbageBasicNumber`,
      body,
    });
  }

  getSummaryMeterList(params) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/meter/meterList`,
      params,
    });
  }

  checkUserHaveSummaryMeter(custId) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/meter/checkMeter/${custId}`,
    });
  }
  // TODO 用户信息结束

  // 删除客户组
  delCustGroups(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custGroup/custGroupDelete`,
      body: value,
    });
  }

  // 请求已绑定用户组的数据
  // getCustRelations(value) {
  //   return this.get({
  //     url: `${this.apiUrl}/api/app/custGroupRelation/custGroupRelations`,
  //     params: {
  //       custGroupId: value.id,
  //       field: value.field,
  //       SkipCount: value.SkipCount || 0,
  //       MaxResultCount: value.MaxResultCount || 10
  //     }
  //   });
  // }

  // 请求未绑定用户组的数据
  getCustUnbound(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custGroupRelation`,
      body: value,
    });
  }

  // 解除绑定用户关系
  UnbindCustGroups(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custGroupRelation/unBindConcentratedCust`,
      body: { custIds: value },
    });
  }

  // 为客户组添加子用户
  custGroupAddSon(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custGroupRelation/bind`,
      body: value,
    });
  }

  // TODO 立户建档开始
  getPriceInfosByOrg(orgId) {
    // 获取站点价格信息
    return this.get({
      url: `${this.apiUrl}/api/app/system/priceInfos/${orgId}`,
      params: {
        lowState: 1,
      },
    });
  }

  getPriceInfosByPopulation(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/system/priceDetailsByPopulation`,
      params: {
        ...value,
      },
    });
  }

  getCustListByKeywords(custCode, type) {
    custCode = custCode.replace(/\s/g, '');
    if (type === 2) {
      return this.get({
        url: `${this.apiUrl}/api/app/custBillType/custFirst`,
        params: {
          custCode,
        },
      });
    } else if (type === 3) {
      return this.get({
        url: `${this.apiUrl}/api/app/custBillType/custBillTypeMain`,
        params: {
          custCode,
        },
      });
    }
  }

  getCurrentUserCodeLength(orgCode) {
    return this.get({
      url: `${this.apiUrl}/api/app/idWorker/rules`,
      params: {
        key: 'CUSTCODE',
        orgCode,
      },
    });
  }

  getCurrentUserCode(orgId, areaId = null, bookId = null) {
    return this.get({
      url: `${this.apiUrl}/api/app/idWorker/single`,
      params: {
        key: 'CUSTCODE',
        orgId,
        areaId,
        bookId,
      },
    });
  }

  getInvoiceList(field) {
    field = field.replace(/\s/g, '');
    return this.get({
      url: `${this.apiUrl}/api/app/cust/invoice`,
      params: {
        field,
      },
    });
  }

  searchCustCollection(field) {
    field = field.replace(/\s/g, '');
    return this.get({
      url: `${this.apiUrl}/api/app/custCollection`,
      params: {
        field,
      },
    });
  }

  searchCustWithholding(field) {
    field = field.replace(/\s/g, '');
    return this.get({
      url: `${this.apiUrl}/api/app/custWithholding`,
      params: {
        field,
      },
    });
  }

  searchCustMeterMainList(code) {
    code = code.replace(/\s/g, '');
    return this.get({
      url: `${this.apiUrl}/api/app/cust/custMeterMainList`,
      params: {
        code,
      },
    });
  }

  getAllMeterModelsByProducer(producereId) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterModels`,
      params: {
        producereId,
      },
    });
  }

  getAllMeterCaliber() {
    return this.get({
      url: `${this.apiUrl}/api/app/meterCaliber`,
    });
  }

  getAllMeterRange() {
    return this.get({
      url: `${this.apiUrl}/api/app/meterRange/meterRangeActive`,
    });
  }

  createCust(data) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust`,
      body: {
        ...data,
      },
    });
  }

  calcDownBill(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/charge/calcDownBill`,
      body: {
        ...value,
      },
    });
  }

  // TODO 立户建档结束
  // 请求集收号的数据
  getCollection(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/concentratedMark/pageList`,
      params: {
        field: value.field,
        SkipCount: value.SkipCount || 0,
        MaxResultCount: value.MaxResultCount || 10,
      },
    });
  }

  // 添加集收号数据
  addconcentrated(value) {
    if (value.id === 0) {
      return this.post({
        url: `${this.apiUrl}/api/app/concentratedMark`,
        body: value,
      });
    } else {
      return this.post({
        url: `${this.apiUrl}/api/app/concentratedMark/update`,
        body: value,
      });
    }
  }

  // 查询集收号单条数据（用于编辑用户）
  getCollectionModel(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/concentratedMark/${id}/model`,
    });
  }

  // 修改集收号
  putCollectionMaek(user) {
    return this.post({
      url: `${this.apiUrl}/api/app/concentratedMark/update`,
      body: user,
    });
  }

  // 删除集收号
  deleteCollectionModel(ids) {
    return this.post({
      url: `${this.apiUrl}/api/app/concentratedMark/bulkDelete`,
      body: ids,
    });
  }

  // 查询已绑定用户清单
  getCollectionCustPage(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/concentratedMark/concentratedCustPage`,
      params: value,
    });
  }

  // 查询未绑定的用户
  getcustPageList(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/concentratedMark/custPageList`,
      body: value,
    });
  }

  // 绑定客户集收关系
  postCustbinding(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/concentratedMark/bind`,
      body: value,
    });
  }

  // 解除绑定客户集收关系
  postconcentratedCust(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/concentratedMark/unbindConcentratedCust`,
      body: value,
    });
  }

  // 解除用户集收号绑定关系
  deletecustbinding(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/concentratedMark/deleteCust/${id}`,
    });
  }

  // TODO 优惠方案工单开始
  getCustPreferentialPlan(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/preferential/model/${custId}`,
    });
  }

  createCustPreferentialPlan(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/preferential`,
      body: {
        ...value,
      },
    });
  }

  completeCustPreferentialPlan(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/preferential/${id}/updateComplete`,
    });
  }

  deleteCustPreferentialPlan(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/preferential/${id}/delete`,
    });
  }

  getExistsCustPreferential(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/preferentialPlan/existsCustPreferential/${custId}`,
    });
  }

  cancelCustPreferential(custId) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/preferential/deletePreferential/${custId}`,
    });
  }

  // TODO 优惠方案工单结束

  // TODO 预存款调整开始
  getDepositAdjustModal(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/depositAdjustRecord/model/${custId}`,
    });
  }
  doDepositAdjustment(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/depositAdjustRecord`,
      body: {
        ...value,
      },
    });
  }

  // TODO 预存款调整结束

  updateInvoiceAndContact(custId) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/invoice/updateInvoice/${custId}`,
    });
  }

  // TODO 定额开始
  searchWaterCust(value, priceCode?) {
    return this.get({
      url: `${this.apiUrl}/api/app/quotaShare/custSearch`,
      params: {
        field: value,
        ...(priceCode ? { priceCode } : {}),
      },
    });
  }

  searchAddSubWaterCust(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/quotaShare/custListSearch`,
      params: {
        ...value,
      },
    });
  }

  addWaterCust(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaShare`,
      body: {
        ...value,
      },
    });
  }

  addWaterCustBatch(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaShare/batch`,
      body: value,
    });
  }

  searchMasterWaterCust(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/quotaShare/pageList`,
      params: {
        ...value,
      },
    });
  }

  searchSubWaterCust(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/quotaShare/pageChildList`,
      params: {
        ...value,
      },
    });
  }

  deleteWaterCust(ids) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaShare/delete`,
      params: {
        input: ids,
      },
    });
  }

  getWaterOverPageList(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaRatifyPageList`,
      body: value,
    });
  }

  createWaterOver(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaRatify`,
      body: {
        ...value,
      },
    });
  }

  editWaterOver(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaRatify/edit`,
      body: {
        ...value,
      },
    });
  }

  searchWaterOverById(id, year?) {
    return this.get({
      url: `${this.apiUrl}/api/app/quotaRatify/detail/${id}`,
      params: {
        year,
      },
    });
  }

  getPriceInfoOverList() {
    return this.get({
      url: `${this.apiUrl}/api/app/waterOverPlan/priceInfoOverList`,
    });
  }

  getOverPlanListByCustCode(custCode) {
    return this.get({
      url: `${this.apiUrl}/api/app/waterOverPlan/waterOverPlanList`,
      params: {
        custCode,
      },
    });
  }

  getWaterOverPlanByPriceCode(priceCode?) {
    return this.get({
      url: `${this.apiUrl}/api/app/waterOverPlan/all`,
      params: {
        ...(priceCode ? { priceCode: priceCode.join(',') } : {}),
      },
    });
  }

  deleteQuotaApproval(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/quotaRatify/${id}/delete`,
    });
  }

  getCustOverType(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/quotaRatify/overCustType/${custId}`,
    });
  }

  // TODO 定额结束

  // 打印
  getPrintFeeDetail(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/billPrint/lodopPrintContent`,
      body: {
        ...value,
      },
    });
  }

  // IC卡充值记录页面
  smartcardLogPageList(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/smartPayment/smartcardLogPageList`,
      params: value,
    });
  }
  // ic卡打印小票
  printICCardCredentials(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/billPrint/lodopICPrintCredentials`,
      body: value,
    });
  }

  // 查询客户绑定的小程序
  getCustBind(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/${custId}/custBind`,
    });
  }

  // 修改合同号
  modifyContract(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/updateContract`,
      body: value,
    });
  }
  // 电子档案
  getElectronicFile(value) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/electronicFile`,
      params: value,
    });
  }
  // 添加电子档案
  addElectronicFile(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/electronicFile`,
      body: value,
    });
  }
  editElectronicRemark(id, remark) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/${id}/updateRemark`,
      params: {
        remark,
      },
    });
  }

  // 删除电子档案附件
  deleteEFilePhoto(files) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/deleteElectronicFile`,
      body: { fileDto: files },
    });
  }
  // 批量保存立户
  reviewOfInsertUploadCust(value, IsBuild) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/reviewOfInsertUploadCust?Save=true&IsBuild=${IsBuild}`,
      body: value,
      timeout: 60000 * 2,
    });
  }

  // 批量修改页面
  // 手工修改
  putCustBatch(value, save) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/putBatch?save=${save}`,
      body: value,
    });
  }
  // 批量修改保存
  reviewOfUpdateUploadCust(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/reviewOfUpdateUploadCust?Save=true`,
      body: value,
    });
  }

  // 客户信息发送短信
  pushMessage(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/push`,
      body: value,
    });
  }
  custField() {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/field`,
    });
  }
  postUpdateChargeInvoiceType(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoice/updateChargeInvoiceType`,
      body: value,
    });
  }
  setOfflineInvoice(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/invoice/setOfflineInvoicingState`,
      body: value,
    });
  }

  changeLogType() {
    return this.get({
      url: `${this.apiUrl}/api/app/operationLog/changLogType`,
    });
  }

  searchTotalPageList(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custAreaMetering/totalPageList`,
      body: value,
    });
  }

  searchDetailPageList(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custAreaMetering/detailPageList`,
      body: value,
    });
  }

  getMeterList(custCode) {
    return this.get({
      url: `${this.apiUrl}/api/app/custAreaMetering/meterList`,
      params: {
        custCode,
      },
    });
  }

  addSubMeter(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custAreaMetering/subMeter`,
      body: value,
    });
  }

  deleteSubMeter(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custAreaMetering/meterdingRemove`,
      body: value,
    });
  }

  updateCustArea(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/custAreaMetering/custAreaUpdate`,
      body: value,
    });
  }

  exportMeterBillRecordList(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/thirdPartyRealTime/exportRealTimeDetails`,
      body,
      headers,
      options,
    });
  }

  exportRecordData(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/meterReading/exportRecordData`,
      body,
      headers,
      options,
    });
  }

  exportCustomers(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/cust/exportCustomers`,
      body,
      headers,
      options,
    });
  }

  exportWaterOver(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/quotaRatify/exportWaterOver`,
      body,
      headers,
      options,
    });
  }
  quotaRatifyExcelDown(body, headers, options) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/quotaRatify/excelDown`,
      body,
      headers,
      options,
    });
  }

  // 用水分析
  getWaterUsage(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/meterWaterUsage/waterUsage/${custId}`,
    });
  }

  // 开户工单
  getOpenAccountStatus(custId) {
    return this.get({
      url: `${this.apiUrl}/api/app/openAccount/openAccountStatus/${custId}`,
    });
  }

  openAccount(value) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/openaccount`,
      body: value,
    });
  }

  // 套餐办理接口开始
  getPackageList(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/package/getList`,
      body,
    });
  }

  postCustPackage(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/package`,
      body,
    });
  }

  exportCustPackage(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/package/export`,
      body,
    });
  }

  cancelCustPackage(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/package/${id}/cancel`,
    });
  }

  getPackageCustInfo(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/package/${id}/custInfo`,
    });
  }

  getContractTemplates(customerType) {
    return this.get({
      url: `${this.apiUrl}/api/app/signaturesTemplateAppServie/contractTemplatesByCustomerType`,
      params: {
        customerType,
      },
    });
  }

  getCertificate(custCode: string) {
    return this.get({
      url: `${this.apiUrl}/api/app/certificate/certificate`,
      params: { custCode },
    });
  }

  saveIDCard(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/saveIDCard`,
      body,
    });
  }

  saveMilitaryID(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/saveMilitaryID`,
      body,
    });
  }

  saveHouseholdRegister(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/saveHouseholdRegister`,
      body,
    });
  }

  savePassport(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/savePassport`,
      body,
    });
  }

  savePropertyCertificate(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/savePropertyCertificate`,
      body,
    });
  }

  saveBusinessLicense(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/saveBusinessLicense`,
      body,
    });
  }

  saveOrganizationCodeCertificate(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/certificate/saveOrganizationCodeCertificate`,
      body,
    });
  }

  //   补差接口开始
  getDifferenceInfo(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/difference/${id}/custInfo`,
    });
  }
  getDifferenceModelInfo(id) {
    return this.get({
      url: `${this.apiUrl}/api/app/cust/difference/model/${id}`,
    });
  }
  postDifferenceInfo(body: any) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/difference`,
      body,
    });
  }
  updateCompleteDifference(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/difference/${id}/updateComplete`,
    });
  }
  deleteDifference(id) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/difference/${id}/delete`,
    });
  }

  // 分页查询报装验收项目
  queryAcceptanceProject(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/queryAcceptanceProject`,
      body,
    });
  }

  // 查询报装验收详情
  queryAcceptanceProjectDetail(projectId) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/queryAcceptanceProject/${projectId}`,
    });
  }

  // 更新报装验收项目
  updateAcceptanceProject(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/updateAcceptanceProject`,
      body,
    });
  }

  // 查询报装验收项目明细
  queryAcceptanceProjectDetails(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/queryAcceptanceProjectDetails`,
      body,
    });
  }

  // 删除项目附件
  deleteProjectAttachment(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/deleteProjectAttachment`,
      body,
    });
  }

  // 发送设备同步命令
  sendDeviceSyncCommand(projectId) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/sendDeviceSyncCommand/${projectId}`,
    });
  }

  // 获取导入模板
  getExcelTemplate(headers?, options?) {
    return this.getFile({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/excelTemplate`,
      headers,
      options,
    });
  }

  // 解析excel文件
  parsingExcel(body, headers?, options?) {
    return this.postFile({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/parsingExcel`,
      body,
      headers,
      options,
    });
  }

  // 登记
  registration(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/registration`,
      body,
    });
  }

  // 提交
  submit(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/submit`,
      body,
    });
  }

  // 驳回
  reject(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/reject`,
      body,
    });
  }

  // 验收
  acceptance(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/acceptance`,
      body,
    });
  }

  // 撤销
  revoke(projectId) {
    return this.post({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/revok/${projectId}`,
    });
  }

  // 获取厂家名称
  getProducerName(producerId) {
    return this.get({
      url: `${this.apiUrl}/api/app/installAcceptanceProject/producerName/${producerId}`,
    });
  }

  // 批量添加联系人
  batchCreateContact(file: any, isSave: boolean, headers?: any, options?: any) {
    const formData = new FormData();
    formData.append('input', file);

    return this.postFile({
      url: `${this.apiUrl}/api/app/contact/batchCreateContact?IsSave=${isSave}`,
      body: formData,
      headers,
      options,
    });
  }

  // 通过客户Id查询主联系人手机号码
  getMainContactPhoneNumber(custId: number | string) {
    return this.get({
      url: `${this.apiUrl}/api/app/contact/mainContactPhoneNumber/${custId}`,
    });
  }

   // 串户相关接口开始
  meterMisallocation(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/meter/meterMisallocation`,
      body,
    });
  }
  getInfoByCustCode(body) {
    return this.post({
      url: `${this.apiUrl}/api/app/cust/meter/getByCustCode`,
      body,
    });
  }
}
